import type { SVGProps } from "react";

export function IconWhiteFastTime(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6468 19C25.5837 15.5432 28.0281 12.6468 30.7479 10.4856C35.3705 6.81244 40.7426 5.29091 45.7942 6.64449C50.8459 7.99806 54.7375 12.0018 56.9042 17.4942C59.0708 22.9864 59.4867 29.92 57.5943 36.9823C55.702 44.0446 51.8751 49.8413 47.2526 53.5144C42.6299 57.1876 37.2579 58.7092 32.2062 57.3556C27.1546 56.002 23.263 51.9983 21.0963 46.5059C20.9027 46.0151 20.7231 45.5129 20.5579 45H18.9863C19.1993 45.7031 19.4378 46.3892 19.701 47.0564C21.997 52.8765 26.2003 57.2992 31.818 58.8045C37.4357 60.3097 43.2872 58.5813 48.1858 54.6888C53.0844 50.7963 57.0761 44.7118 59.0432 37.3705C61.0103 30.0292 60.5956 22.7641 58.2995 16.9437C56.0035 11.1235 51.8002 6.70086 46.1825 5.1956C40.5648 3.69034 34.7133 5.41883 29.8147 9.31125C26.7401 11.7544 24.0228 15.0611 21.939 19H23.6468Z"
        fill="#23232C"
      />
      <path
        d="M12 32H28M4 23H21M4 41H21M43.1411 16.5452L38.1331 35.2352L42.3715 40.6679"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
